/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityDataleaksInnerData
 */
export interface MonitEntityDataleaksInnerData {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityDataleaksInnerData
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityDataleaksInnerData
     */
    count?: number;
}

/**
 * Check if a given object implements the MonitEntityDataleaksInnerData interface.
 */
export function instanceOfMonitEntityDataleaksInnerData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityDataleaksInnerDataFromJSON(json: any): MonitEntityDataleaksInnerData {
    return MonitEntityDataleaksInnerDataFromJSONTyped(json, false);
}

export function MonitEntityDataleaksInnerDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityDataleaksInnerData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function MonitEntityDataleaksInnerDataToJSON(value?: MonitEntityDataleaksInnerData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'count': value.count,
    };
}

